export default __webpack_public_path__ + "static/media/icon-coin.4f5b0c75.png";